import ServiceBus from 'servicestack/service-bus'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'
import modals from 'webmodals/modals'
import templateUrl from 'emun.salesrep/product-sales-popup.htm'
import AutoQuery from 'servicestack/auto-query/auto-query'

class controller {
    constructor(options) {
        const $ctrl = this;
        basicController($ctrl);
        $ctrl.bus = new ServiceBus();
        $ctrl.title = options.title || `Product Sales`;
    }
}

export default (options) => modals.open(Object.assign({
    size: options.size || 'lg',
    templateUrl,
    resolve: {
        options: () => options
    },
    bindToController: true,
    controller,
    controllerAs: '$ctrl'
}, (options || {}).modal)).result;